<a
  (click)="handleMainMenuAction()"
  (keydown.enter)="handleMainMenuAction()"
  role="button"
  tabindex="0"
  class="nav-link"
  [ngClass]="{ active: isMainActive || isOneOfChildrenActive }">
  <i class="nav-icon {{ menuItem.iconClasses }}"></i>
  <p>
    {{ menuItem.name }}
    <i
      *ngIf="isExpandable && menuItem.children.length > 0"
      class="right fas fa-angle-right"
      [@rotate]="isMenuExtended"></i>
  </p>
</a>

<ul class="nav nav-treeview" *ngIf="isMenuExtended">
  <li class="nav-item" *ngFor="let item of menuItem.children">
    <a
      (click)="handleSubMenuAction(item)"
      [routerLink]="item.path"
      [routerLinkActive]="'active'"
      role="link"
      tabindex="0"
      class="nav-link"
      style="margin-left: 10px">
      <i class="nav-icon {{ item.iconClasses }}"></i>
      <p>
        {{ item.name }}
        <i
          *ngIf="item.children && item.children.length > 0"
          class="right fas fa-angle-right"
          [@rotate]="item.isSubMenuExtended"></i>
      </p>
    </a>

    <ul
      class="sub-item"
      *ngIf="item.isSubMenuExtended"
      style="list-style-type: none">
      <li *ngFor="let subItem of item.children">
        <a
          [routerLink]="subItem.path"
          [routerLinkActive]="'active'"
          role="link"
          tabindex="0"
          class="nav-link">
          <i class="nav-icon {{ subItem.iconClasses }}"></i>
          <p>{{ subItem.name }}</p>
        </a>
      </li>
    </ul>
  </li>
</ul>
